import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { GSDevTools } from 'gsap/GSDevTools'
import { lenis, scrollTo } from './lenis'

gsap.registerPlugin(SplitText, GSDevTools, ScrollTrigger) 

class About {
	constructor(section) {
		this.section = section
		this.heading = section.querySelector('.about-intro__heading')
		this.cloudsTop = section.querySelector('.about-intro__cloud-layer-top')
		this.cloudsMiddle = section.querySelector('.about-intro__cloud-layer-middle')
		this.cloudsBottom = section.querySelector('.about-intro__cloud-layer-bottom')
		this.cloudsBottom2 = section.querySelector('.about-intro__cloud-layer-bottom-2')
		this.door = section.querySelector('.about-intro__frame')
		this.doorLeft = section.querySelector('.about-intro__door-left')
		this.doorRight = section.querySelector('.about-intro__door-right')
		this.background = section.querySelector('.about-intro__background')
		this.scroll = section.querySelector('.about-intro__scroll')
		this.banner = document.querySelector('.banner-about')
		this.bannerHeading = this.banner.querySelector('.banner-about__heading')
		this.cherub1 = section.querySelector('.about-intro__cherub--1')
		this.cherub2 = section.querySelector('.about-intro__cherub--2')
		this.init()
	}

	init() {
		lenis.stop()
		this.startIntroAnimation()
		this.updateHeaderColours()
		this.section.classList.add('ready')
	}

	startIntroAnimation() {

		gsap.set([this.cloudsTop, this.cloudsMiddle, this.cloudsBottom, this.cloudsBottom2], {
			willChange: 'transform, filter',
			force3D: true
		})
		
		gsap.set([this.heading, this.door], {
			willChange: 'transform, opacity, filter',
			force3D: true
		})

		this.split = SplitText.create(this.heading, {
			type: 'chars, words',
			charsClass: 'char++'
		})

		this.timelineIntroduction = gsap.timeline({
			delay: 0.5,
			onComplete: () => {
				console.log('ScrollTriggerUpdate')
				ScrollTrigger.update()
			}
		})

		.fromTo(this.heading, {
			opacity: 0,
			filter: 'blur(10px)'
		}, {
			opacity: 1,
			duration: 1.4,
			filter: 'blur(0px)',
			ease: 'power1.inOut'
		})

		.fromTo(this.split.chars, {
			opacity: 0.1
		}, {
			opacity: 1,
			stagger: 0.05,
			duration: 1.2
		})

		.to(this.heading, {
			opacity: 0,
			scale: 1.05,
			duration: 1.2,
			ease: 'power1.inOut'
		}, 5)

		.fromTo(this.door, {
			opacity: 0,
			scale: 0.8
		}, {
			opacity: 1,
			scale: 1,
			duration: 2.4,
			ease: 'power1.out',
			onComplete: () => {
				this.scrollThroughDoorAnimation()
				this.scroll.classList.add('active')
			}
		}, 6)

		.fromTo(this.cloudsTop, {
			scale: 1
		}, {
			scale: 2,
			filter: 'blur(10px)',
			duration: 15,
			ease: 'power1.inOut'
		}, 0)

		.to(this.cherub1, {
			x: 440,
			y: 100,
			duration: 1.2,
			ease: 'power3.inOut'
		}, 0)

		.to(this.cherub1, {
			x: 0,
			y: 200,
			duration: 1.2,
			ease: 'power3.inOut'
		}, 3)

		.to(this.cherub2, {
			x: -300,
			y: 100,
			duration: 1.2,
			ease: 'power3.inOut'
		}, 0.5)

		.to(this.cherub2, {
			x: 0,
			y: 300,
			duration: 1.2,
			ease: 'power3.inOut'
		}, 3.5)

		.fromTo(this.cloudsMiddle, {
			filter: 'blur(10px)',
		}, {
			filter: 'blur(0px)',
			duration: 4,
			ease: 'power1.inOut'
		}, 2)
		
		.fromTo(this.cloudsMiddle, {
			scale: 1,
		}, {
			scale: 1.75,
			duration: 15,
			ease: 'power1.inOut'
		}, 2)

		.fromTo(this.cloudsBottom, {
			filter: 'blur(20px)',
			opacity: 0.5
		}, {
			filter: 'blur(0px)',
			opacity: 1,
			duration: 6,
			ease: 'power1.inOut'
		}, 4)
		
		.fromTo(this.cloudsBottom, {
			scale: 1,
		}, {
			scale: 1.5,
			duration: 15,
			ease: 'power1.inOut'
		}, 4)

		.to(this.cloudsBottom, {
			filter: 'blur(10px)',
			duration: 4,
			ease: 'power1.inOut'
		}, 10)

		.fromTo(this.cloudsBottom2, {
			filter: 'blur(20px)',
			opacity: 0
		}, {
			filter: 'blur(0px)',
			opacity: 1,
			duration: 6,
			ease: 'power1.inOut'
		}, 6)
		
		.fromTo(this.cloudsBottom2, {
			scale: 1,
		}, {
			scale: 1.25,
			duration: 15,
			ease: 'power1.inOut'
		}, 6)

		// GSDevTools.create({animation: this.timelineIntroduction})

	}

	scrollThroughDoorAnimation = () => {

		this.background.classList.add('masked')
		lenis.start()

		this.timelineScrollThroughDoor = gsap.timeline({
			scrollTrigger: {
				trigger: this.section,
				start: 'top top',
				end: '1000vh',
				scrub: 1
			}
		})
	
		this.timelineScrollThroughDoor.to(this.doorLeft, {
			duration: 1.2,
			transformOrigin: 'left',
			rotateY: -125,
			ease: 'power3.inOut',
		})
	
		this.timelineScrollThroughDoor.to(this.doorRight, {
			duration: 1.2,
			transformOrigin: 'right',
			rotateY: 125,
			ease: 'power3.inOut',
		}, '<')
	 
		this.timelineScrollThroughDoor.to(this.section, {
			duration: 1,
			scale: 10,
			force3D: true,
			ease: 'power4.in',
			willChange: 'transform',
		})

		this.timelineScrollThroughDoor.fromTo(this.bannerHeading, {
			opacity: 0,
			filter: 'blur(10px)'
		}, {
			opacity: 1,
			filter: 'blur(0px)',
			duration: 1.2,
			ease: 'power1.inOut',
			onComplete: () => {
				this.section.remove()
				this.timelineIntroduction.kill()
				this.timelineScrollThroughDoor.kill()
			}
		}, 1.5)
	}

	updateHeaderColours = () => {
		const header = document.querySelector('.header')

		ScrollTrigger.create({
			trigger: this.banner,
			start: 'bottom top+=70px',
			// markers: true,
			onEnterBack: () => {
				header.classList.remove('header--colour')
			},
			onLeave: () => {
				header.classList.add('header--colour')
			}
		})
	}
}

export const initAbout = () => {
	const section = document.querySelector('.about-intro')

	if (!section) return	

	const about = new About(section)
}

export default () => {}